export enum ERole {
  ROLE_USER = 'ROLE_USER',
  ROLE_CLIENTE = 'ROLE_CLIENTE',
  ROLE_CLIENTEUSR = 'ROLE_CLIENTEUSR',
  ROLE_CLIENTE_CHECKOUT = 'ROLE_CLIENTE_CHECKOUT',
  ROLE_CLIENTE_LIQ = 'ROLE_CLIENTE_LIQ',
  ROLE_ADMIN = 'ROLE_ADMIN',
  ROLE_ADMIN_MODIFICAR_SP = 'ROLE_ADMIN_MODIFICAR_SP',
}
